<script setup lang="ts">
import MLink from "../MLink";

defineProps({
  title: String,
  items: {
    type: Array,
    default() {
      return [];
    },
  },
});
</script>
<template>
  <div class="m-link-list">
    <p class="empty-text">{{ title }}</p>
    <ul>
      <li v-if="items.length === 0" class="empty">
        <m-link to="#" disabled> None </m-link>
      </li>
      <template v-else>
        <li v-for="(item, i) in items" :key="i">
          <slot name="item" v-bind="{ item, i }">
            <m-link v-bind="item" />
          </slot>
        </li>
      </template>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.m-link-list {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height */

  letter-spacing: 0.01em;

  //color: var(--grey-dark);

  ul {
    margin-left: 0;
    padding-inline-start: 1em;

    li {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;

      margin: 8px 0;
    }
  }
}
</style>
